exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@keyframes animatedgradient{}.tcf-fb-group-answer-preview.tcf-fb-group-answer-tab .form-row .tcf-fb-forms-group-preview__title{margin-bottom:20px;margin-top:0;color:rgba(0,0,0,.5);font-size:16px;line-height:1.2;font-weight:400}", ""]);

